<template>
	<v-card flat>
		<v-container class="">
			<v-layout row wrap>
				<v-flex xs12 md8 offset-md2>
					<v-card flat>
						<v-card-text>Approximate benefit you gained from items loaned with your library membership.</v-card-text>
						<apexchart width="100%" type="bar" :options="yearOptions" :series="yearSeries"></apexchart>
					</v-card>
				</v-flex>
				<v-flex xs12 md8 offset-md2>
					<v-card flat>
						<apexchart width="100%" type="donut" :options="collectionOptions" :series="collectionSeries"></apexchart>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
    </v-card>

</template>

<script>

export default {
	name: 'HistorySavingsTab',
	data ( ) {
		return {
			yearOptions: {
				title: {
					text: 'Benefit by Year',
					align: 'center'
				},
				tooltip: {
					x: {
						format: 'yyyy'
					},
					y: {
						formatter: function( y ) {
							if ( typeof y !== "undefined" ) {
								return "$" + y.toFixed( 0 );
							}
							return y;
						},
						title: {
							formatter: function( title ) {
								return '';
							}
						}
					}
				},
				plotOptions: {
					bar: {
						horizontal: false,
						dataLabels: {
							position: 'top'
						}
					},
				},
				dataLabels: {
					style: {
						colors: [ 'black' ],
					},
					formatter: function( val, opt ) {
						return "$" + val.toFixed( 0 );
					},
					offsetY: -20
				},
				xaxis: {
					type: 'datetime',
					tickAmount: 'dataPoints',
					tickPlacement: 'on',
					labels: {
						hideOverlappingLabels: false,
					}
				},
				chart: {
					toolbar: {
						show: false
					},
					zoom: {
						enabled: false
					},
					events: {
						dataPointSelection: ( event, chartContext, config ) => {
							var year = config.w.config.series[ 0 ].data[ config.dataPointIndex ].x;
							if ( this.yearFilter == year ) {
								this.yearFilter = '';
							} else {
								this.yearFilter = year;
							}
							console.log( this.yearFilter );
						}
					}
				}
			},
			collectionOptions: {
				title: {
					text: 'Breakdown by Collection',
					align: 'center'
				},
				labels: [ ],
				dataLabels: {
					enabled: true
				},
				chart: {
					events: {
						dataPointSelection: ( event, chartContext, config ) => {
							var collection = config.w.config.labels[ config.dataPointIndex ];
							if ( this.collectionFilter == collection ) {
								this.collectionFilter = '';
							} else {
								this.collectionFilter = collection;
							}
							console.log( this.collectionFilter );
						}
					}
				}
			},
			yearFilter: '',
			collectionFilter: ''
		}
	},
	mounted( ) {
	},
	computed: {
		yearSeries( ) {
			var collections = this.$store.getters[ 'patron/collections' ];
//			console.log( collections );
			var data = this.$store.getters[ 'patron/borrowingHistory' ];
			var totals = data.reduce( function( counts, item ) {
				var year = item.checkOutDate.getFullYear( );
				var collection = collections[ item.collection ];
				// check if we know the collection
				if ( collection == undefined ) {
					// nope, so why not just use AF
					//return counts;
					collection = collections[ 'AF' ];
				}
				if ( counts.hasOwnProperty( year ) ) {
					counts[ year ].count += collection.cost;
				} else {
					counts[ year ] = {
						code: year,
						count: collection.cost
					}
				}
				return counts;
			}, { } );
//			console.log( totals );
			return [ { data: Object.values( totals ).map( function( item ) { return { x: item.code, y: item.count }; } ) } ];
		},
		collectionSeries( ) {
			var collections = this.$store.getters[ 'patron/collections' ];
			console.log( collections );
			var data = this.$store.getters[ 'patron/borrowingHistory' ];
			console.log( data );
			var totals = data.reduce( function( counts, item ) {
				var collection = collections[ item.collection ];
				if ( collection == undefined ) {
					return counts;
				}
				if ( counts.hasOwnProperty( collection.code ) ) {
					counts[ collection.code ].count += 1;
				} else {
					counts[ collection.code ] = {
						code: collection.code,
						label: collection.description,
						count: 1
					}
				}
				return counts;
			}, { } );
			console.log( totals );

			var series = Object.values( totals ).reduce( function( items, item ) {
				items.series.push( item.count );
				items.labels.push( item.label );
				return items;
			}, { series: [ ], labels: [ ] } );
			console.log( series );
			this.collectionOptions.labels = series.labels;
			return series.series;
//			return [ { data: Object.values( totals ).map( function( item ) { return { x: item.code, y: item.count }; } ) } ];
		}
	},
	watch: {
	},
	methods: {
	}
}
</script>
